import React from "react";
import { TextInput } from "../../../components/input_hook_form";
import "./style.scss";

function Performance(props) {
  const { register, show, mode, errors } = props;
  // readOnly, not disabled: react-hook-form drops disabled inputs from the
  // submit, and the fund save still sends the country code.
  const locked = mode === "VIEW" || mode === "EDIT";
  const editable = (rules) => (locked ? {} : rules);

  return (
    <div
      className={show ? "performance-container" : "performance-container-hide"}
    >
      {locked ? (
        <p className="performance-note">
          These values come from the Portal NAV sync and the performance CSV
          upload, and cannot be edited here.
        </p>
      ) : null}
      <TextInput
        label={"Country Code"}
        placeholder={"Country Code"}
        error={!locked && errors["performance-countrycode"]}
        register={register(editable({
          required: true,
          minLength: 1
        }))}
        type={"text"}
        name="performance-countrycode"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Fund Code"}
        placeholder={"Fund Code"}
        error={!locked && errors["performance-fundcode"]}
        register={register(editable({
          required: true,
          minLength: 1
        }))}
        type={"text"}
        name="performance-fundcode"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Fund ID"}
        placeholder={"Fund ID"}
        error={!locked && errors["performance-fundid"]}
        register={register(editable({ required: true }))}
        type={"number"}
        name="performance-fundid"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Return YTD"}
        placeholder={"Return YTD"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="performance-returnytd"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Return 03months"}
        placeholder={"Return 03months"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="performance-return03months"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Return 06months"}
        placeholder={"Return 06months"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="performance-return06months"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Return 12months"}
        placeholder={"Return 12months"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="performance-return12months"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Return 03years"}
        placeholder={"Return 03years"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="performance-return03years"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Return 05years"}
        placeholder={"Return 05years"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="performance-return05years"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Return 10years"}
        placeholder={"Return 10years"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="performance-return10years"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Return Since Inception"}
        placeholder={"Return Since Inception"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="performance-returnsinceinception"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"NAV per unit"}
        placeholder={"NAV per unit"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="performance-navperunit"
        readOnly={locked}
      />
      <div className="performance-spacer" />
      <TextInput
        label={"Total NAV"}
        placeholder={"Total NAV"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0000000001}
        type={"number"}
        name="performance-totalnav"
        readOnly={locked}
      />
    </div>
  );
}

export default Performance;
